// extracted by mini-css-extract-plugin
export default {"companyContainer":"nK-z","companyImage":"oK-z","container":"pK-z","heading":"qK-z","darkText":"rK-z","smallHeading":"sK-z","darkBackground":"tK-z","whiteBackground":"uK-z"};